import { render, staticRenderFns } from "./MetricasMedico2.vue?vue&type=template&id=a27e7468&scoped=true"
import script from "./MetricasMedico2.vue?vue&type=script&lang=js"
export * from "./MetricasMedico2.vue?vue&type=script&lang=js"
import style0 from "./MetricasMedico2.vue?vue&type=style&index=0&id=a27e7468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27e7468",
  null
  
)

export default component.exports